import React, { Component } from 'react'
import PropTypes from 'prop-types'

class TypeWriter extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayText: '',
      index: 0
    }
  }

  componentDidMount() {
    this.startTyping()
  }

  componentWillUnmount() {
    /* eslint-disable no-unused-expressions */
    this._timeout && clearTimeout(this._timeout)
  }

  getText() {
    const { text } = this.props
    return typeof text === 'string' ? [text] : [...text]
  }

  startTyping = () => {
    this._timeout = setTimeout(() => {
      this.type()
    }, this.props.startingDelay)
  }

  erase = () => {
    /* eslint-disable prefer-const */
    let { index, displayText } = this.state

    // moves to the next word or restarts typing of string
    if (displayText.length === 0) {
      const textArray = this.getText()

      index = index + 1 === textArray.length ? 0 : index + 1

      this.setState({ index }, () => {
        this.startTyping()
      })
    }

    // otherwise remove last letter from displayText
    else {
      // prettier-ignore
      displayText = displayText.substr(-displayText.length, displayText.length - 1)

      this.setState({ displayText }, () => {
        this._timeout = setTimeout(() => {
          this.erase()
        }, this.props.erasingSpeed)
      })
    }
  }

  type() {
    let { index, displayText } = this.state

    // calls function that turns string into array and selects first index
    const text = this.getText()[index]

    if (text.length > displayText.length) {
      // first/next letter of the text to type on screen
      displayText = text.substr(0, displayText.length + 1)

      this.setState({ displayText }, () => {
        this._timeout = setTimeout(() => {
          this.type()
        }, this.props.typingSpeed)
      })
    }

    // otherwise call function to start deleting text
    else {
      this._timeout = setTimeout(() => {
        this.erase()
      }, this.props.delay)
    }
  }

  render() {
    const { displayText } = this.state
    const { className } = this.props

    return process.env.GATSBY_ACTIVE_ENV !== 'testing' ? (
      <div className={className ? `typewriter typewriter--${className}` : 'typewriter'}>
        {displayText}
        <span>|</span>
      </div>
    ) : (
      'Lorem Ipsum '
    )
  }
}

/* eslint-disable react/require-default-props */
TypeWriter.defaultProps = {
  startingDelay: 1000,
  typingSpeed: 75,
  delay: 500,
  erasingSpeed: 100
}

TypeWriter.propTypes = {
  className: PropTypes.string,
  delay: PropTypes.number,
  erasingSpeed: PropTypes.number,
  startingDelay: PropTypes.number,
  typingSpeed: PropTypes.number,
  text: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired
}

export default TypeWriter
